import API from "../../api/chartservice"
const state = {
  getIsShow: false,
};

const getters = {
  getIsShow: (state) => state.getIsShow,
};

const actions = {
  updateDownloadHandler({ commit }, isShow) {
    commit("SET_UPDATE_DOWNLOAD_SHOW_MODAL", isShow);
  },
  async chartUpdateUploadHandler({ commit, getters }, reqdata) {
    // console.log("reqdata", reqdata);
    // commit("LOADING_SPINNER_SHOW", true);
    try {
      const { data } = await API.chartUpdateUploadService(
        getters.getToken,
        reqdata
      );
      let resdata = data;
      let status = data.status;
      // commit("LOADING_SPINNER_SHOW", false);
      if (status == 201) {
        return resdata;
      } else {
        return resdata;
      }
    } catch (error) {
      // commit("LOADING_SPINNER_SHOW", false);
      // handleError(error);
      console.error(error);
    }
  },
  async chartDownloadHandler({ commit, getters }, reqdata) {
    // console.log("reqdata", reqdata);
    // commit("LOADING_SPINNER_SHOW", true);
    try {
      const { data } = await API.chartDownloadService(
        getters.getToken,
        reqdata
      );
      let resdata = data;
      let status = data.status;
      // commit("LOADING_SPINNER_SHOW", false);
      if (status == 201) {
        return resdata;
      } else {
        return resdata;
      }
    } catch (error) {
      // commit("LOADING_SPINNER_SHOW", false);
      // handleError(error);
      console.error(error);
    }
  },
};
const mutations = {
  SET_UPDATE_DOWNLOAD_SHOW_MODAL: (state, isShow) => {
    state.getIsShow = isShow;
  },
};

export default {
    state,
    getters,
    actions,
    mutations,
  };